var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutubeBurgerWhite = function SvgYoutubeBurgerWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49.878,
    height: 49.878,
    x: 0.123,
    y: 0.355,
    fill: "#717172",
    rx: 24.939
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.166 34.094a3.2 3.2 0 0 1-1.3-.75 3.1 3.1 0 0 1-.801-1.252c-.916-2.449-1.187-12.674.576-14.693a3.42 3.42 0 0 1 2.305-1.125c4.73-.497 19.34-.43 21.018.165.472.15.903.401 1.261.737s.634.745.807 1.2c1 2.53 1.034 11.73-.136 14.163a3.17 3.17 0 0 1-1.474 1.456c-1.763.86-19.916.844-22.256.099m7.51-4.798 8.474-4.302-8.475-4.335z",
    clipRule: "evenodd"
  })));
};
export default SvgYoutubeBurgerWhite;